export default __webpack_public_path__ + "static/pokeball-1404629520cfb510cc1d1872ff100d8e.png";